import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HowToUploadVideos: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Button onClick={() => navigate('/blog')} sx={{ mb: 3, textTransform: 'none' }}>
          {t('blog.backToBlog')}
        </Button>

        <Typography variant="overline" color="primary" sx={{ fontWeight: 600 }}>
          Creators · June 2026
        </Typography>
        <Typography variant="h3" component="h1" sx={{ my: 2, fontWeight: 700 }}>
          How to Upload Videos on IndeeClips
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, lineHeight: 1.85 }}>
          A step-by-step guide to uploading your first video on IndeeClips and reaching thousands of Indian viewers.
        </Typography>

        <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>
          Step 1: Create Your Account
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.85 }}>
          Visit the IndeeClips app or website and sign up using your email or phone number. Complete your profile with
          your name and profile picture.
        </Typography>

        <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 700 }}>
          Step 2: Set Up Your Channel
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.85 }}>
          Navigate to the Channel section and click "Create Channel". Give your channel a unique name and tag, add a
          description that tells viewers what content to expect, and select relevant categories.
        </Typography>

        <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 700 }}>
          Step 3: Upload Your Video
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.85 }}>
          Click on the Upload button, select your video file from your device, and add an eye-catching thumbnail image
          to attract more viewers.
        </Typography>

        <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 700 }}>
          Step 4: Choose Category & Age Limit
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.85 }}>
          Select the most relevant category for your video (Comedy, Music, Education, etc.) and set the appropriate age
          restriction if your content is not suitable for all audiences.
        </Typography>

        <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 700 }}>
          Step 5: Publish Your Video
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, lineHeight: 1.85 }}>
          Add a compelling title and description with relevant keywords. Click "Upload" and your video will be
          processed and published within minutes!
        </Typography>

        <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>
          Video Requirements
        </Typography>
        <Box component="ul" sx={{ '& li': { mb: 1, color: 'text.secondary', lineHeight: 1.85 } }}>
          <li>Supported formats: MP4, MOV, AVI, MKV</li>
          <li>Maximum file size: 2GB per video</li>
          <li>Recommended resolution: 1080p or 720p for best quality</li>
        </Box>

        <Typography variant="body1" color="text.secondary" sx={{ mt: 4, lineHeight: 1.85 }}>
          Need help? Contact us at{' '}
          <Typography
            component="a"
            href="mailto:contact@indeeclips.com"
            sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
          >
            contact@indeeclips.com
          </Typography>
        </Typography>
      </Container>
    </Box>
  );
};

export default HowToUploadVideos;
